/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchDogsResultTitles_item$ref: FragmentReference;
declare export opaque type SearchDogsResultTitles_item$fragmentType: SearchDogsResultTitles_item$ref;
export type SearchDogsResultTitles_item = {|
  +prefixes: ?string,
  +suffixes: ?string,
  +$refType: SearchDogsResultTitles_item$ref,
|};
export type SearchDogsResultTitles_item$data = SearchDogsResultTitles_item;
export type SearchDogsResultTitles_item$key = {
  +$data?: SearchDogsResultTitles_item$data,
  +$fragmentRefs: SearchDogsResultTitles_item$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchDogsResultTitles_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prefixes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "suffixes",
      "storageKey": null
    }
  ],
  "type": "SearchDogsResult",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '23e9b0cce12ac15204620593ad14fbe3';

module.exports = node;
